module.exports = __webpack_public_path__ + "img/turquoise.0f873f12.png";